import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Grid } from 'elements';
import Information from 'components/case/parts/Information';
import Write from 'components/case/parts/Write';
import { getCaseItem, getCaseMenteeExplainDetail } from 'libs/api/case';
import { getUrlQuery } from 'libs/utils';
import { TCase, TCaseExplainDetail } from 'modules/case/types';
import { Spin } from 'antd';
import { Colors } from 'GlobalStyles';

const CaseWrite = () => {
  const location = useLocation();
  const { explain } = getUrlQuery(location.search);
  const { id }: { id: string } = useParams();
  const [cs, setCs] = useState<TCase>();
  const [detail, setDetail] = useState<TCaseExplainDetail>();

  const getCase = async () => {
    const { success, data } = await getCaseItem(id);
    if (success) setCs(data.result);
  };

  const getExplain = async () => {
    const { success, data } = await getCaseMenteeExplainDetail(explain);
    if (success) {
      setDetail({
        id: data.id,
        user_rating: data.user_rating,
        mentor_ratings: data.mentee_ratings,
        rating_count: data.rating_count,
        comments_count: data.comments_count,
        title: data.title,
        content: data.content,
        mentor: {
          name: data.mentee_name,
          profile_image: data.mentee_profile_image,
          university: data.mentee_university,
          major: data.mentee_major,
        },
        question: data.question,
        key_question: data.key_question,
        created_at: data.created_at,
        hit_count: data.hit_count,
        thumbnail: data.thumbnail,
        files: data.files,
      });
    }
  };

  useEffect(() => {
    getCase();
    if (explain) getExplain();
  }, []);

  if (!cs) {
    return (
      <Grid justify='center' align='center' height='100px' margin='0 0 150px 0' md={{ margin: '0 0 80px 0' }}>
        <Spin spinning />
      </Grid>
    );
  }

  return (
    <Grid justify='center' margin='0 0 150px 0' md={{ margin: '0 0 80px 0' }}>
      <Information item={cs} refresh={getCase} />
      <Grid style={{ borderTop: `1px solid ${Colors.grey1}` }} />
      {(explain === undefined || (explain !== undefined && detail)) && <Write id={id} detail={detail} />}
    </Grid>
  );
};

export default CaseWrite;
